
import {
  Autocomplete,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _, { size } from "lodash";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import * as XLSX from 'xlsx'; // Importing xlsx library
import html2pdf from 'html2pdf.js';
const OutletSalesManReport = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const outlet_id = localStorage.getItem("outlet_id");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [salesManData, setSalesManData] = useState([]);
  const [custSalesMan, setCustSalesMan] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0); // overall amount in footer
  const [totalAvgAmount, setTotalAvgAmount] = useState(0); // overall amount in footer
  const [averageamt, setAverageAmount] = useState(0); // overall amount in footer
  const [totalFlag, setTotalFlag] = useState(false); // set the total flag true
  const [cust, setCust] = useState(null);
  const [totalCount, setTotalCount] = useState(0); // total count of rows
const [totalBill, setTotalBill] = useState(0); // total of bills
const tableRef = useRef(null);
  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().startOf('month').format(),
    toDate: moment().format(),
  });

  const getSupplierData = () => {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => setSupplier(res.data))
      .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error || "Error fetching suppliers")));
  };

  // const getSalesMan = () => {
  //   // axios.get('/v1/SalesMan')
  //   axios.get(`v1/SalesMan/outlets/${outlet_id}`)

  //     .then(res => setSalesManData(res.data))
  //     .catch(err => dispatch(setSnackbar(true, "error", err.response?.data?.error || "Error fetching salesmen")));
  // };
  const getSalesMan = (outletId) => {
    let endpoint = outletId && outletId !== 0 ? `/v1/SalesMan/outlets/${outletId}` : `/v1/SalesMan`; // Adjust for "All"
    axios
      .get(endpoint)
      .then((res) => {
        const salesmen = res.data;
        setSalesManData([{ id: 0, sales_man_name: "" }, ...salesmen]); // Add "All" option
      })
      .catch((err) =>
        dispatch(setSnackbar(true, "error", err.response?.data?.error || "Error fetching salesmen"))
      );
  };
  // const getSalesMan = (outletId) => {
  //   axios
  //     .get(`/v1/SalesMan/outlets/${outletId}`)
  //     .then((res) => setSalesManData(res.data))
  //     .catch((err) =>
  //       dispatch(setSnackbar(true, "error", err.response?.data?.error || "Error fetching salesmen"))
  //     );
  // };
   // Handle outlet selection change
   const handleOutletChange = (event, value) => {
    setCust(value); // Set selected outlet
    if (value) {
      getSalesMan(value.id); // Fetch salesmen for the selected outlet
    }
  };
  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      minWidth: 50,
      maxWidth: 70,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
    },
    {
      field: "code",
      headerName: "Employee Code",
      minWidth: 100,
      maxWidth: 120,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "name",
      headerName: "Employee Name",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "total_bill",
      headerName: "Total Bills",
      minWidth: 90,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "sales",
      headerName: "Total Sales",
      minWidth: 90,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "salesman_avg_amount",
      headerName: "Avg Sales Per Bill",
      minWidth: 90,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
  ];

let overallCounter = 1; // Initialize overall counter outside of the flatMap function

const rows = _.flatMap(data, (val) => {
  const totalSalesAmount = val.salesman_lines.reduce((acc, salesman) => acc + parseFloat(salesman.total_amount || 0), 0);
  const totalBillsCount = val.salesman_lines.reduce((acc, salesman) => acc + parseFloat(salesman.total_bill || 0), 0);
  const averageBillValue = totalBillsCount > 0 ? (totalSalesAmount / totalBillsCount).toFixed(0) : 0;

  // Create the branch header row (displayed only once at the start of each branch)
  const branchHeader = {
    id: `branch-${overallCounter}`, // Unique ID for the branch header
    sno: 'Branch Name', // Label for branch name
    name: '',          // No value for name
    code: val.fullname === "" ? "-" : val.fullname,          // No value for code
    sales: '',         // No value for sales
    total_bill: '',    // No value for total bills
    OutletName: val.fullname === "" ? "-" : val.fullname, // Branch name
  };
  // const totalAverageAmount = parseFloat(
  //   val.salesman_lines.reduce((acc, salesman) => acc + parseFloat(salesman.salesman_avg_amount || 0), 0)
  // ).toFixed(2);
  // const totalAverageAmount = Math.round(
  //   val.salesman_lines.reduce((acc, salesman) => acc + parseFloat(salesman.salesman_avg_amount || 0), 0)
  // );
  
  const totalAverageAmount = Math.round(
    val.salesman_lines.reduce(
      (acc, salesman) => acc + Math.round(parseFloat(salesman.salesman_avg_amount || 0)),
      0
    ) * 100
  ) / 100;
  
  // Map salesman rows
  const salesmanRows = val.salesman_lines.map((salesman) => ({
    id: `${overallCounter}`, // Unique ID for each entry
    sno: overallCounter++, // Use overall counter for serial number
    name: salesman.sales_man_name,
    code: salesman.sales_man_code,
    sales: parseFloat(salesman.total_amount).toFixed(0),
    total_bill: salesman.total_bill,
    OutletName: '', // No need to repeat branch name here
    // salesman_avg_amount: totalAverageAmount
    // salesman_avg_amount: Number(parseFloat(salesman.salesman_avg_amount).toFixed(2))
    salesman_avg_amount: Number((Math.round(parseFloat(salesman.salesman_avg_amount))))

  }));

  // Add the average row for the branch
  const averageRow = {
    id: `avg-${overallCounter}`,
    sno: 'Avg',
    name: 'Total',
    code: '',
    sales: parseFloat(val.total_amount).toFixed(0),
    total_bill: val.total_bill,
    OutletName: '', // No need to repeat branch name here either
    // salesman_avg_amount: parseFloat(val.avg_amount).toFixed(2)
    salesman_avg_amount: Number((Math.round(parseFloat(val.avg_amount))).toFixed(0))
    // salesman_avg_amount: Number((Math.round(parseFloat(totalAverageAmount))).toFixed(2))
  };

  // Return the branch header first, followed by the salesman rows and the average row
  return [branchHeader, ...salesmanRows, averageRow];
});

  const averageAmounts = _.uniqBy(
    _.map(data, (value) => {
      return {
        averageAmount: value.avg_amount === "" ? "-" : value.avg_amount,
        TotalAmount: value.total_amount === "" ? "-" : value.total_amount,
        TotalBill: value.total_bill === "" ? "-" : value.total_bill,
      };
    }),
    'averageAmount' // Ensure uniqueness based on OutletName
  );
  

  console.log(rows,"rowsssss");
  
  const exportToPDF = () => {
    const element = tableRef.current; // Get the current table reference
    // const options = {
    //   margin: 1,
    //   filename: "Salesman_Report.pdf",
    //   image: { type: "jpeg", quality: 0.98 },
    //   html2canvas: { scale: 2 },
    //   jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    // };
    const options = {
      margin: 0.2,
      filename: "Salesman_Report.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true }, // UseCORS helps with capturing external resources
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" }, // A4 is a common paper size
      pagebreak: { avoid: ['tr', 'td', 'th'] }, // Avoid breaking rows
    };
  
    // Generate PDF
    html2pdf()
      .from(element)
      .set(options)
      .save();
  };
  const exportToExcel = () => {
    const workbook = XLSX.utils.book_new();
  
    // Create the worksheet from the main data rows
    const worksheet = XLSX.utils.json_to_sheet(rows.map(row => ({
      "S.no": row.sno,
      "Employee Code": row.code,
      "Employee Name": row.name,
      "Total Bills":  Number(row.total_bill)|| "",
      "Total Sales": Number(row.sales) || "",
      "Avg Sales Per Bill": row.salesman_avg_amount,
    })));
  
    // Calculate total values
    const totalBills = rows.reduce((acc, row) => acc + (parseFloat(row.total_bill) || 0), 0);
    const totalSales = rows.reduce((acc, row) => acc + (parseFloat(row.sales) || 0), 0);
    
    // Calculate the average bill value
    // const averageBillValue = totalBill > 0 ? (totalAmount / totalBill).toFixed(2) : 0;
    const averageBillValue = totalBill > 0 ? Math.round(totalAmount / totalBill) : 0;

    // Create the footer data
    const footerData = [
      { "S.no": '', "": "","Employee Name": '', "Total Bills": "", "Total Sales": ""},
      { "S.no": 'Total Average Bill Value', "": averageBillValue,"Employee Name": 'Total', "Total Bills": totalBill, "Total Sales": totalAmount,}
      // { "S.no": 'Total Average Bill Value', "": averageBillValue,"Employee Name": 'Total', "Total Bills": totalBill, "Total Sales": totalAmount ,"Avg Sales Per Bill":totalAvgAmount},
    ];

    // Append footer data to the worksheet
    const footerStartRow = rows.length + 2; // Position for footer (2 rows below the last data row)
    XLSX.utils.sheet_add_json(worksheet, footerData, { skipHeader: true, origin: `A${footerStartRow}` });
  
    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Salesman Report");
  
    // Write the file
    XLSX.writeFile(workbook, "Salesman_Report.xlsx");
  };
  
  useEffect(() => {
    setTotalFlag(true);
    const total = data.reduce((acc, val) => acc + (parseFloat(val.sales) || 0), 0);
    setTotalAmount(total.toFixed(0));
  }, [data]);

  const handleChange = (e, name) => {
    setDateLimit(prev => ({ ...prev, [name]: dayjs(e).format() }));
  };
  const handleSalesmanReport = () => {
    const postData = {
      from_date: moment(dateLimit.fromDate).format('YYYY-MM-DD'),
      to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
      outlet: cust?.id || 0,
      salesman: custSalesMan?.id || 0,
    };

    axios.post(`/v1/reports/salesman/getall/new`, postData)
      .then(res => {
        setData(res.data);
        setPageCount(res.data.length);
        console.log(res.data, "response");
      })
      .catch(err => {
        const error = err.response?.data?.errors?.[0];
        if (error?.code === "NOT_FOUND") {
          setData([]);
          setPageCount(0);
          dispatch(setSnackbar(true, "error", error.message));
        } else {
          dispatch(setSnackbar(true, "error", error?.message || "An unexpected error occurred."));
        }
      });
  };

console.log(data,"dataaa");

  useEffect(() => {
    getSupplierData();
    getSalesMan();
  }, []);

  useEffect(() => {
    if (dateLimit.fromDate && dateLimit.toDate) {
      handleSalesmanReport();
    }
  }, [rowsPerPage, page, dateLimit, cust, custSalesMan]);

useEffect(() => {
  if (!Array.isArray(data) || data.length === 0) {
    setTotalAmount(0);
    setTotalCount(0);
    setTotalBill(0);
    setTotalFlag(false);
    return; // Exit early if data is invalid
  }

  // Calculate total sales and total bills
  const totalSales = data.reduce((acc, val) => {
    const totalAmountForSalesman = val.salesman_lines.reduce((sum, salesman) => sum + parseFloat(salesman.total_amount || 0), 0);
    return acc + totalAmountForSalesman;
  }, 0);

  const totalBills = data.reduce((acc, val) => {
    const totalBillForSalesman = val.salesman_lines.reduce((sum, salesman) => sum + parseFloat(salesman.total_bill || 0), 0);
    return acc + totalBillForSalesman;
  }, 0);
  const totalAvgAmount = data.reduce((acc, val) => {
    const totalaverageForSalesman = val.salesman_lines.reduce((sum, salesman) => sum + parseFloat(salesman.salesman_avg_amount || 0), 0);
    return acc + totalaverageForSalesman;
  }, 0);
  const roundedTotalAvgAmount = Math.round(totalAvgAmount);

      const averageBillValue = totalBills > 0 ? (totalSales / totalBills).toFixed(0) : 0; // Calculate average
      setTotalAmount(totalSales.toFixed(0)); // Set total sales
      setTotalCount(totalBills); // Set total bills count
      setAverageAmount(averageBillValue); // Set Avg Sales Per Bill
      setTotalAvgAmount(roundedTotalAvgAmount.toFixed(0)); // Set Avg Sales Per Bill
      setAverageAmount(0);
  setTotalAmount(totalSales.toFixed(0));
  setTotalBill(totalBills.toFixed(0));
  setTotalFlag(true);
}, [data]);


  return (
    <Fragment>
      <Helmet><title>Outlet Salesman Reports</title></Helmet>
      <Typography variant="h6">Outlet Salesman Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          {/* <Autocomplete
            size="small"
            options={[{ id: 0, fullname: "All" }, ...supplier]}
            onChange={(e, value) => setCust(value)}
          
            getOptionLabel={option => option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet" />}
          /> */}
          <Autocomplete
          size="small"
            options={supplier}
            getOptionLabel={(option) => option.fullname || ""}
            value={cust}
            onChange={handleOutletChange}
            renderInput={(params) => <TextField {...params} label="Select Outlet" variant="outlined" />}
          />
        </Grid>
        <Grid item md={3}>
          {/* <Autocomplete
            size="small"
            options={salesManData}
            onChange={(e, value) => setCustSalesMan(value)}
            getOptionLabel={(option) => `${option.sales_man_name} - ${option.sales_man_code}`}
            renderInput={(params) => <TextField {...params} label="Select Salesman" />}
          /> */}
          <Autocomplete
          size="small"
            options={salesManData}
            getOptionLabel={(option) => option.sales_man_name || ""}
            value={custSalesMan}
            onChange={(e, newValue) => setCustSalesMan(newValue)}
            renderInput={(params) => <TextField {...params} label="Select Salesman" variant="outlined" />}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label: 'From',
                  style: { width: '100%' },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label: 'To',
                  style: { width: '100%' },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <Grid className='text-end my-2'>
        <Button onClick={exportToExcel} variant="outlined"   sx={{ marginRight: "20px" }}>Export to Excel</Button>
        <Button onClick={exportToPDF} variant="outlined">Download PDF</Button> {/* Button for PDF download */}

      </Grid>
      <Grid className='flex' >

      <TableContainer className={classes.tblRoot} sx={{height:"500px",overflow:"auto",}}>
      <Table  ref={tableRef} size="small">
      <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
      <TableRow className={classes.tablrow} >
        
              {columns.map((col) => (
                <TableCell
                  key={col.field}
                  align={col.align}
                  
                  style={{ minWidth: col.minWidth, maxWidth: col.maxWidth }}
                >
                  {col.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody >
            {rows.map((row) => (
              <TableRow key={row.id}  >
                <TableCell sx={{borderLeft:`1px solid #ccc`,width: 100}} align="center"
                 style={{
                  fontWeight: row.sno === 'Branch Name' ? 'bold' : 'normal', // Make bold if it's the average row
                  fontSize: row.sno === 'Branch Name' ? '16px' : 'inherit', // Set font size to 16px if it's the average row
                }}
                >{row.sno}</TableCell>
                
                <TableCell sx={{borderLeft:`1px solid #ccc`,width: 200 }} align="center"
                 style={{
                  fontWeight: row.sno === 'Branch Name' ? 'bold' : 'normal', // Make bold if it's the average row
                  fontSize: row.sno === 'Branch Name' ? '16px' : 'inherit', // Set font size to 16px if it's the average row
                }}
                >{row.code}</TableCell>
                <TableCell
                sx={{borderLeft:`1px solid #ccc`,width: 200}} align="center"
        style={{
          fontWeight: row.sno === 'Avg' ? 'bold' : 'normal', // Make bold if it's the average row
          fontSize: row.sno === 'Avg' ? '16px' : 'inherit', // Set font size to 16px if it's the average row
        }}
      >
        {row.name}
      </TableCell>

                <TableCell sx={{borderLeft:`1px solid #ccc`,width: 150}} align="center"
                 style={{
                  fontWeight: row.sno === 'Avg' ? 'bold' : 'normal', // Make bold if it's the average row
                  fontSize: row.sno === 'Avg' ? '16px' : 'inherit', // Set font size to 16px if it's the average row
                }}
                >{row.total_bill}</TableCell>
                <TableCell sx={{borderLeft:`1px solid #ccc`,width: 150}} align="center"
                 style={{
                  fontWeight: row.sno === 'Avg' ? 'bold' : 'normal', // Make bold if it's the average row
                  fontSize: row.sno === 'Avg' ? '16px' : 'inherit', // Set font size to 16px if it's the average row
                }}
                >{row.sales}</TableCell>
                <TableCell sx={{borderLeft:`1px solid #ccc`,width: 150}} align="center"
                 style={{
                  fontWeight: row.sno === 'Avg' ? 'bold' : 'normal', // Make bold if it's the average row
                  fontSize: row.sno === 'Avg' ? '16px' : 'inherit', // Set font size to 16px if it's the average row
                }}
                >{row.salesman_avg_amount}
                
                </TableCell>
              </TableRow>
              
            ))}
          
          </TableBody>
          {totalFlag && (
    <TableFooter>

             
 
        <TableRow >

          <>
<TableCell colSpan={2} align="right" style={{ fontSize: "18px", fontWeight: 'bold' }}>
Total Average Bill: {totalBill > 0 ? (totalAmount / totalBill).toFixed(0) : "Not Calculated"}
{/* Total Average Bill Value :{averageamt} */}
</TableCell>
 <TableCell colSpan={1} align="right" style={{ fontSize: "18px", fontWeight: 'bold' }}>
Total Sales
</TableCell>
<TableCell align="center" style={{ fontSize: "14px", fontWeight: 'bold' }}> {totalBill}</TableCell>
<TableCell align="center" style={{ fontSize: "14px", fontWeight: 'bold' }}>{totalAmount}</TableCell>
{/* <TableCell align="center" style={{ fontSize: "14px", fontWeight: 'bold' }}>{totalAvgAmount}</TableCell> */}

</>
          
           
        </TableRow>
    </TableFooter>
)}
        </Table>
      </TableContainer>
      </Grid>
    </Fragment>
  );
};

// export default OutletSalesManReport;
export default memo(OutletSalesManReport);